
import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { getCompanyAddressInfo, ShopAddressListDto } from "@/api/buyCar";
import { editCompanyAddressInfo, addCompanyAddressInfo } from "@/api/my";
import { validatePhoneNumber } from "@/utils/util";
import { toBaiDuMap, openAddressbook } from "@/utils/h5ToApp";

@Component
export default class EditAddress extends Vue {
  @Getter companyId!: string;
  autoId = "";
  isLoading = false;
  formData = {
    isDefault: false,
    receiveMan: "",
    receiveMobile: "",
    address: "",
    addressDtl: "",
    longitude: 0,
    latitude: 0,
    jraddress: "",
  };
  // 调用原生enterSelectAddress方法去选择收获地址
  selectAddress() {
    // // 防止键盘高度没收回，跳出去回来后页面高度变化
    // setTimeout(() => {
    //   const data = {
    //     customerId: this.companyId,
    //     isShowTemporary: false, // 是否展示临时地址信息 传false就是不展示，true就是展示
    //     title: "请选择所在地区",
    //   };
    //   this.$bridge.callHandler("enterSelectAddress", { data }, (res) => {
    //     const data = !res ? {} : JSON.parse(res);
    //     const {
    //       address,
    //       addressDtl,
    //       receiveMobile,
    //       receiveMan,
    //       longitude,
    //       latitude,
    //       jraddress,
    //     } = data;
    //     this.formData.address = address;
    //     this.formData.addressDtl = addressDtl;
    //     this.formData.receiveMobile = receiveMobile;
    //     this.formData.receiveMan = receiveMan;
    //     this.formData.longitude = longitude;
    //     this.formData.latitude = latitude;
    //     this.formData.jraddress = jraddress;
    //   });
    // }, 100);

    // toBaiDuMap().then((res: any) => {
    //   this.$set(this.formData, "address", res.address);
    //   this.$set(this.formData, "addressDtl", res.addressDtl);
    //   this.$set(this.formData, "longitude", res.longitude);
    //   this.$set(this.formData, "latitude", res.latitude);
    //   this.$set(this.formData, "jrAddress", res.address);
    // });

    this.$router.push({
      path: '/addressMap',
      query: {
        longitude: String(this.formData.longitude),
        latitude: String(this.formData.latitude),
      }
    })
  }
  /**
   * 获取用户手机通讯录
   * (跟原生对接)
   */
  handleContacts(item: any) {
    openAddressbook().then((res: { name?: string; mobile?: string }) => {
      console.log(res);
      if (res && res.name) {
        item.receiveMan = res.name;
      }
      if (res && res.mobile) {
        item.receiveMobile = res.mobile;
      }
    });
  }
  // 提交
  onSubmit() {
    console.log(this.formData);
    if (this.isLoading) return;
    (this.$refs.handleForm as any)
      .validate()
      .then(async () => {
        if (!validatePhoneNumber(this.formData.receiveMobile)) {
          this.$toast("请输入正确的手机号");
          return;
        }
        this.isLoading = true;
        let res;
        let params: any = {
          ...this.formData,
          isDefault: this.formData.isDefault ? 1 : 0,
        };
        if (this.autoId && this.autoId !== "") {
          params = {
            autoId: this.autoId,
            ...params,
          };
          res = await editCompanyAddressInfo(params);
        } else {
          // params =
          //   {
          //     isDefault: 1,
          //     receiveMan: "马先生",
          //     receiveMobile: "18813926576",
          //     address: "广东省深圳市南山区粤海街道",
          //     addressDtl: "金融科技大厦",
          //     longitude: 22.55069855643813,
          //     latitude: 113.9436849200905,
          //     jraddress: "广东省深圳市南山区",
          //   };
          const addParams = {
            companyId: this.companyId,
            addressList: [params],
          };
          res = await addCompanyAddressInfo(addParams);
        }

        if (res.code === "000000") {
          this.$toast("保存成功");
          this.$router.replace({ name: "AddressManage" });
        } else {
          this.$toast("保存失败");
        }
        this.isLoading = false;
      })
      .catch((res) => {
        this.$toast("必填信息未输入，请输入");
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  async getDetail() {
    const res = await getCompanyAddressInfo({ companyId: this.companyId });
    if (res.data.addressList && res.data.addressList.length > 0) {
      const curData = res.data.addressList.find(
        (item) => item.autoId === this.autoId
      );
      if (curData) {
        this.formData = {
          isDefault: curData.isDefault === 1,
          receiveMan: curData.receiveMan,
          receiveMobile: curData.receiveMobile,
          address: curData.address,
          addressDtl: curData.addressDtl,
          longitude: curData.longitude,
          latitude: curData.latitude,
          jraddress: curData.jraddress,
        };
      }
    }
  }

  created() {
    const id = this.$route.query.autoId as string;
    if (id) {
      this.autoId = id;
      this.getDetail();
    }
    const addressInfoStr = window.sessionStorage.getItem('editStoreAddressInfo')
    if (addressInfoStr) {
      try {
        const addressInfo = JSON.parse(addressInfoStr)
        this.formData = {
          ...this.formData,
          ...addressInfo,
          addressDtl: addressInfo.receiveAddressDtl,
        };
      } catch (e) {
        console.error('解析sessionStorage地址信息失败:', e)
      }
    }
  }
}
